
import { IDanhGiaKetQuaSelectRequest } from "../../../models/request/danh-gia/IDanhGiaKetQuaSelectRequest";
import { IDotDanhGiaKetQuaSubmitRequest } from "../../../models/request/danh-gia/IDotDanhGiaKetQuaSubmitRequest";
import { IDotDanhGiaKetQua } from "../../../models/response/danh-gia/IDotDanhGiaKetQua";
import { ISoNhanXetItem } from "../../../models/response/dgdk-dm/ISoNhanXetItem";
import { generateActionTypeIds } from "../generateActionTypeIds";
import IGenericActionType from "../IGenericActionType";

export const eDanhGiaKetQuaActionTypeDefine = {
    CHANGE_FILTER: {} as IDanhGiaKetQuaSelectRequest,

    LOAD_START: {} as IDanhGiaKetQuaSelectRequest,
    LOAD_SUCCESS: {} as IDotDanhGiaKetQua[],
    LOAD_ERROR: "",

    CHANGE_SELECTED_IDS: {} as number[],

    CHANGE_QUICK_INPUT_ITEM: {} as ISoNhanXetItem | undefined,


    SAVE_START: {} as IDotDanhGiaKetQuaSubmitRequest<IDotDanhGiaKetQua[]>,
    SAVE_SUCCESS: {} as IDotDanhGiaKetQua[],
    SAVE_ERROR: "",


}
export const eDanhGiaKetQuaActionTypeIds = generateActionTypeIds(eDanhGiaKetQuaActionTypeDefine, "DANH_GIA_KET_QUA")

export type IDanhGiaKetQuaActions = IGenericActionType<typeof eDanhGiaKetQuaActionTypeDefine, "DANH_GIA_KET_QUA">